import { CloseOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import React, {
  useCallback,
  useEffect,
  useRef,
} from 'react'
import { Navigation } from 'swiper/modules'
import {
  Swiper,
  SwiperRef,
  SwiperSlide,
} from 'swiper/react'

import MediaView from '@/components/shared/media-view'
import { Media } from '@/model/media'

import s from './media-slider.module.css'
import 'swiper/css'
import 'swiper/css/navigation'

export interface MediaSliderProps {
  open: boolean
  setOpen: (open: boolean) => void
  index: number
  medias: Media[]
}

export function MediaSlider({
  open,
  setOpen,
  index,
  medias,
}: MediaSliderProps) {
  const swiperRef = useRef<SwiperRef>(null)
  const hideSwiper = useCallback(() => setOpen(false), [setOpen])
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper.activeIndex !== index) {
      swiperRef.current.swiper.slideToLoop(index, 0)
    }
  }, [index])

  return (
    <div
      className={classNames(s.SwiperContainer, { [s.display]: open })}
      onClick={(event) => event.stopPropagation()}
    >
      <Swiper
        modules={[Navigation]}
        navigation
        className={s.Swiper}
        loop
        ref={swiperRef}
      >
        {medias.map((mediaItem, idx) => (
          <SwiperSlide key={`${mediaItem.id}-${idx}`}>
            {({ isActive }) => (
              isActive && open &&
              <MediaView className={s.SwiperMedia} media={mediaItem} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      <CloseOutlined className={s.CloseSwiper} onClick={hideSwiper} />
    </div>
  )
}
